import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from '../home.service';
import { FileService } from '../../shared/fileService';
@Component({
  selector: 'app-form-audits',
  templateUrl: './form-audits.component.html',
  styleUrls: ['./form-audits.component.scss']
})
export class FormAuditsComponent implements OnInit {
  isLoading:boolean = false;
  forumData:any;
  formbuilder;
  headerName=[];
  userData= []
  userId:any;
  formId:any;
  date = "";
  circleId:any
  vId:any;
  navigateFrom:any;
finalList = [];
downloadList= [];
  constructor(
    private homeService:HomeService,
    private route:ActivatedRoute,
    private router: Router,
    private fileService:FileService
    ) { }

    from = ""
  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
      this.navigateFrom = param["from"];
      this.formId = param["formId"];
      this.circleId = param["circleId"];
      this.userId = param["userId"];
      this.from = param['from']
      this.vId = param["vId"];
      if (param) {
          this.getFormAuditData();
      }
    });
  }


  queryParams() {
    let query = ""
      query = "formId="+this.formId+"&groupedVersionsId="+this.vId;
    // let query = "&limit=" + this.pagelimit + "&offset=" + this.pagelimit * this.currentPage;;
    if (this.date && this.date !== "") {
      let tempDate = this.getEpoc(this.date)
      query = query + "&date=" + tempDate.toLowerCase().trim();
    }
    return query;
  }

  getEpoc(date) {
    let travelDay = date.getDate();
    if (travelDay < 10) travelDay = "0" + travelDay;
    let travelMonth =date.getMonth() + 1;
    if (travelMonth < 10) travelMonth = "0" + travelMonth;
    let travelYear = date.getFullYear();
    return travelMonth+"/"+travelDay+"/"+travelYear
  }

  formData :any
  tabHeaders =[];
  responses:[String[]];
  getFormAuditData() {
    this.isLoading = true
let query = this.queryParams()

    this.homeService.getFormAuditsApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          
          this.tabHeaders = res.data.headerNames;
          this.responses = res.data.responses;
          this.formData =res.data.formData;
          //this.downloadList = []
          for (let i = 0; i < this.responses.length; i++) {
            let obj = {};
            for (let j = 0; j < this.responses[i].length; j++) {
              obj[this.tabHeaders[j]] = this.responses[i][j];
            }
            this.downloadList.push(obj);
          }
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  onFilterChange () {
    this.getFormAuditData()
  }
  resetFilter() {
    this.date = "";
    this.getFormAuditData();
  }

  navigateBAck(){
    if (this.navigateFrom == 'Admin') {
      this.router.navigate(["main/setting/manage-forum/viewForum"]);
    } else {
      this.router.navigate(["/main/user-response-form-view"],{ queryParams: { userId:this.userId,from:this.from,formId:this.formId,circleId:this.circleId}, preserveQueryParams: false });
    }
   
  }
  
  exportAsXLSX(): void {
    var todayTime = new Date();
    let currentTimeEpoch = Date.now();
    let date = new Date(currentTimeEpoch);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    this.fileService.exportAsExcelFile(this.downloadList,this.formData['title']+"_"+ month + "/" + day + "/" + year);
  }
}

